__turbopack_context__.v({
  "questionnaireContent": "QuestionnaireContent-module__yNtMKW__questionnaireContent",
  "questionnaireContentWrapper": "QuestionnaireContent-module__yNtMKW__questionnaireContentWrapper",
});
